var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paginator flex-level" }, [
    _vm.pagination.total > 0
      ? _c("div", { staticClass: "mx-2 fs-3" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$l10n.n__(
                  "%s ligne",
                  "%s lignes",
                  _vm.pagination.total,
                  _vm.pagination.total
                )
              ) +
              "\n    "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.displayActions && _vm.pagination.last_page > 0
      ? _c(
          "div",
          { staticClass: "flex-level mx-2" },
          [
            _c(
              "div",
              { staticClass: "flex-level w-120 white-bkg page-indicator" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.current_page,
                      expression: "current_page"
                    }
                  ],
                  staticClass: "no-border primary-50 aright hp-10 p-0 wp-5",
                  attrs: { type: "number" },
                  domProps: { value: _vm.current_page },
                  on: {
                    change: function($event) {
                      return _vm.goToPage()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.current_page = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "dinlineb wp-4" }, [
                  _vm._v(" / " + _vm._s(_vm.pagination.last_page))
                ])
              ]
            ),
            _vm._v(" "),
            _c("CompassIconButton", {
              attrs: {
                icon: "caret-left",
                size: "small",
                disabled: _vm.current_page === 1
              },
              on: {
                click: function($event) {
                  return _vm.prevPage()
                }
              }
            }),
            _vm._v(" "),
            _c("CompassIconButton", {
              attrs: {
                icon: "caret-right",
                size: "small",
                disabled: _vm.current_page === _vm.pagination.last_page
              },
              on: {
                click: function($event) {
                  return _vm.nextPage()
                }
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }